"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _UIFloatingButtonGroup = _interopRequireDefault(require("UIComponents/button/UIFloatingButtonGroup"));

var _ActionButtons = _interopRequireDefault(require("./ActionButtons"));

var _utils = require("composer-plugins/lib/utils");

var ACTION_BUTTONS_CLASSNAME = 'question-and-answer-content-component-options';
var QUESTION_AND_ANSWER_CLASS = 'question-and-answer-content';

function shouldEventHideActionButtons(event) {
  var target = event.toElement || event.relatedTarget;
  var isContainedByOptionMenu = (0, _utils.targetIsOrContainedByEl)("." + ACTION_BUTTONS_CLASSNAME, target);
  var isContainedByTile = (0, _utils.targetIsOrContainedByEl)("." + QUESTION_AND_ANSWER_CLASS, target);

  if (isContainedByOptionMenu || isContainedByTile) {
    return false;
  }

  return true;
}

var ActionButtonsProvider = function ActionButtonsProvider(_ref) {
  var children = _ref.children,
      onEditClicked = _ref.onEditClicked,
      onDeleteClicked = _ref.onDeleteClicked,
      disabled = _ref.disabled,
      hideEditButton = _ref.hideEditButton;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var child = _react.default.Children.only(children);

  if (disabled) {
    return child;
  }

  var onMouseLeave = function onMouseLeave(event) {
    if (shouldEventHideActionButtons(event)) {
      setOpen(false);
    }
  };

  var childWithListeners = _react.default.cloneElement(child, {
    onMouseEnter: function onMouseEnter() {
      return setOpen(true);
    },
    onMouseLeave: onMouseLeave
  });

  return _react.default.createElement(_UIFloatingButtonGroup.default, {
    buttonGroup: _react.default.createElement(_ActionButtons.default, {
      open: open,
      className: ACTION_BUTTONS_CLASSNAME,
      onMouseLeave: onMouseLeave,
      onEditClicked: onEditClicked,
      onDeleteClicked: onDeleteClicked,
      hideEditButton: hideEditButton
    }),
    open: open
  }, childWithListeners);
};

ActionButtonsProvider.propTypes = {
  disabled: _propTypes.default.bool.isRequired,
  onEditClicked: _propTypes.default.func,
  onDeleteClicked: _propTypes.default.func.isRequired,
  children: _propTypes.default.node.isRequired,
  hideEditButton: _propTypes.default.bool
};
ActionButtonsProvider.defaultProps = {
  hideEditButton: false
};
var _default = ActionButtonsProvider;
exports.default = _default;
module.exports = exports.default;